<template>
  <div class="card">
    <div class="card-body" ref="searchBox">
      <div class="d-flex with-button">
        <div class="p-2">
          <h1>성적 분포</h1>
        </div>
        <div class="p-2 small bottom">
          총 <strong><span class="number mint">{{tableTotal}}</span></strong> 건
        </div>
      </div>

      <div class="d-flex">
        <div class="p-2 w-100">
          <div class="input-group search">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input type="text" class="form-control" aria-describedby="basic-addon1" v-model="search.search_text" @keyup.enter="retrieve" placeholder="시험명">
            <div class="input-group-apend">
              <button type="button" class="btn btn-default" @click="retrieve">
                 검색
              </button>
            </div>
          </div>
        </div>
        <div class="p-2 search-detail" v-if="searchDetailVisible">
          <a href="#" class="arrowdown"><i class="fas fa-angle-double-down"></i></a>
        </div>
      </div>
    </div>

    <stone-data-table-server
      ref="dataTableServer"
      table-ref="dataTableServer"
      :loading="searchLoading"
      :columns="examTableColumns"
      :data="tableData"
      :table-props="defaultTableProps"
      @query-change="tableLoadData"
      @row-click="rowClickHandler">
    </stone-data-table-server>

  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M070101',
  mixins: [common.mixins],
  data () {
    return {
      tableData: [],
      tableTotal: 0,
      search: {
        search_text: '',
        title: '',
        stat: 'C'
      }
    }
  },
  created () {
    this.retrieveDummy()
  },
  methods: {
    retrieve () {
      const queryInfo = {page: 1, pageSize: 20, type: 'init', filters: [], sort: {}}
      this.tableLoadData(queryInfo)
      this.$refs.dataTableServer.localCurrentPage = 1
    },
    async tableLoadData (queryInfo, isClear = false) {
      if (this.checkedPageLoadInit(queryInfo)) {
        return
      }
      const param = Object.assign({query: queryInfo}, this.search)
      // console.log('param : ', param)
      this.loadStoneDataTable('/exam/list', param, true, false)
        .then(response => {
          this.tableData = response.data
          this.tableTotal = this.tableData && this.tableData.length > 0 ? this.tableData[0].total_count : 0
          this.setQueryParamPaging(isClear)
        })
    },
    goEdit (examSeq) {
      const routerName = 'M070102'
      const param = {
        exam_seq: examSeq
      }
      // this.$router.push({name: 'M070102', params: param})
      this.routerPageChangeServer(routerName, param)
    },
    rowClickHandler (row, event, column) {
      this.goEdit(row.exam_seq)
    },
    onPopStateEventHandler () {
      if (this.$store.getters.page_params.query_info) {
        this.$route.params.query_info = this.$store.getters.page_params.query_info
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/M070101.vue